import {makeAutoObservable} from 'mobx';
import {api} from '../api/api';
import {EChannel, IFile} from '../types/types';
import {IRootStore} from './RootStore';

export interface IFilesStore {
    channelFileLoaded?: EChannel;
    files: {
        [channelId: string]: IFile
    };
    loadFile: (id: string, channelId: EChannel) => void;
    loadFileSuccess: (channelId: EChannel) => (file: IFile) => void;
    rootStore: IRootStore;
}

class FilesStore implements IFilesStore {
    channelFileLoaded?: EChannel;
    files: {
        [channelId: string]: IFile
    } = {};
    rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        this.rootStore = rootStore;

        makeAutoObservable(this);
    }

    loadFile = (id: string, channelId: EChannel) => {
        if (this.files[id]) {
            throw new Error(`Файл с id - ${id} уже загружен.`)
        }
        api.getFile(id)
            .then(this.loadFileSuccess(channelId))
            .catch(e => this.rootStore.errorsStore.addError(e));
    };

    loadFileSuccess = (channelId: EChannel) => (file: IFile) => {
        this.files[channelId] = file;
        this.channelFileLoaded = channelId
    };
}

export default FilesStore;
